import dayjs from "dayjs";

const addBusinessDays = (date: Date, days: number) => {
    if(days > 0) {
        let newDate = dayjs(date).add(1, 'day');
        if(newDate.day() == 0 || newDate.day() == 6) {
            return addBusinessDays(newDate.toDate(), days);
        } else {
            return addBusinessDays(newDate.toDate(), days - 1);
        }
    } else if(days < 0) {
        let newDate = dayjs(date).subtract(1, 'day');
        if(newDate.day() == 0 || newDate.day() == 6) {
            return addBusinessDays(newDate.toDate(), days);
        } else {
            return addBusinessDays(newDate.toDate(), days + 1);
        }
    } else {
        return date;
    }
}

export default addBusinessDays;
